// Legacy CakeCRM stored agent_notes as HTML. The CRM editor is a plain
// markdown textarea, so those notes render as raw `<p>...</p>` soup while
// editing. Normalize on load; saving then persists clean markdown.
//
// ponytail: regex, not a parser — the legacy tag set is <p>/<br>/<a>/<strong>,
// output is markdown (which the editor, MarkdownView and the mobile Markdown
// component all already speak), and a mis-parse degrades to slightly odd text.
// Text with no tags is returned untouched, so this is idempotent.
export function htmlNotesToMarkdown(value: string | null | undefined): string {
  const s = value ?? '';
  if (!/<[a-z/][^>]*>/i.test(s)) return s;
  return s
    // A link whose text is its own URL stays a bare URL — no [url](url) noise.
    .replace(/<a\b[^>]*href=["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/gi, (_m, href: string, text: string) => {
      const label = text.replace(/<[^>]+>/g, '').trim();
      return !label || label === href.trim() ? href : `[${label}](${href})`;
    })
    .replace(/<(strong|b)\b[^>]*>([\s\S]*?)<\/\1>/gi, '**$2**')
    .replace(/<(em|i)\b[^>]*>([\s\S]*?)<\/\1>/gi, '*$2*')
    .replace(/<li\b[^>]*>/gi, '\n- ')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|h[1-6]|ul|ol|tr|table|blockquote)>/gi, '\n\n')
    .replace(/<[^>]+>/g, '')
    // One prod row carries an unterminated "</p" (no closing >), which the
    // strip above cannot see. Drop bare tag-name remnants too.
    .replace(/<\/?(?:p|br|div|span|strong|em|b|i|a|ul|ol|li|h[1-6])\b/gi, '')
    // &amp; last, so "&amp;lt;" does not decode all the way to "<".
    .replace(/&nbsp;/gi, ' ')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#0?39;|&apos;/gi, "'")
    .replace(/&amp;/gi, '&')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
